var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "form-group row -mt-4",
      attrs: {
        "align-h": "center",
        role: "radiogroup",
        "aria-labelledby":
          _vm.title + (_vm.componentIndex ? _vm.componentIndex : ""),
        "aria-describedby": _vm.id + "-errors"
      }
    },
    [
      _c("div", { staticClass: "col-12 col-md-4 col-lg-3 col-form-label" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-secondary mt-0 login-page-button",
            attrs: {
              btnid: "showTermsBtn",
              type: "button",
              disabled: _vm.btndisabled,
              "aria-disabled": _vm.btndisabled
            },
            on: {
              click: function($event) {
                return _vm.btnClick()
              }
            }
          },
          [_vm._v("\n      " + _vm._s(_vm.$t(_vm.btnText)) + "\n    ")]
        )
      ]),
      _vm._v(" "),
      _c("ValidationProvider", {
        attrs: {
          rules: _vm.mergedRules,
          name: _vm.title + (_vm.componentIndex ? _vm.componentIndex : ""),
          slim: "",
          mode: _vm.providerMode
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(ref) {
              var errors = ref.errors
              var failedRules = ref.failedRules
              return [
                _c("div", { staticClass: "col-md-8 col-lg-9 col-12 mt-2" }, [
                  _c(
                    "div",
                    {
                      class: _vm.getValidationErrorClasses(failedRules),
                      staticStyle: { "padding-left": "3px" }
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.currentValue,
                            expression: "currentValue"
                          }
                        ],
                        attrs: {
                          id:
                            _vm.title +
                            (_vm.componentIndex ? _vm.componentIndex : "") +
                            "_input",
                          name:
                            _vm.title +
                            (_vm.componentIndex ? _vm.componentIndex : ""),
                          type: "checkbox",
                          disabled: _vm.isInputDisabled,
                          "aria-disabled": _vm.isInputDisabled,
                          "aria-invalid":
                            !_vm.isInputDisabled && errors.length > 0
                        },
                        domProps: {
                          checked: Array.isArray(_vm.currentValue)
                            ? _vm._i(_vm.currentValue, null) > -1
                            : _vm.currentValue
                        },
                        on: {
                          change: function($event) {
                            var $$a = _vm.currentValue,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  (_vm.currentValue = $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  (_vm.currentValue = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.currentValue = $$c
                            }
                          }
                        }
                      }),
                      _vm._v(" "),
                      _vm.label
                        ? _c(
                            "label",
                            {
                              staticClass: "checkbox-label mt-1",
                              attrs: {
                                for:
                                  _vm.title +
                                  (_vm.componentIndex
                                    ? _vm.componentIndex
                                    : "") +
                                  "_input"
                              }
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.$t(_vm.label)) +
                                  "\n          "
                              ),
                              _vm.required
                                ? _c(
                                    "i",
                                    { staticClass: "fas fa-asterisk icon red" },
                                    [
                                      _c("span", { staticClass: "sr-only" }, [
                                        _vm._v(_vm._s(_vm.$t("Icon.Required")))
                                      ])
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.instructionKey
                                ? _c("tooltip-icon", {
                                    attrs: {
                                      content: _vm.$t(_vm.instructionKey)
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: errors.length > 0,
                          expression: "errors.length > 0"
                        }
                      ],
                      staticClass: "mb-2 inline-validation-error",
                      attrs: { id: _vm.id + "-errors" }
                    },
                    [_vm._v(_vm._s(_vm.getSingleValidationErrorMsg(errors)))]
                  )
                ])
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }